import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  type: '',
  content: '',
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setNotification(state, action) {
      return action.payload;
    },
    resetNotification() {
      return initialState;
    },
  },
});

export const { setNotification, resetNotification } = notificationSlice.actions;

export default notificationSlice.reducer;
